export default __webpack_public_path__ + "static/media/grafema_clivitalbio_12.a2c5bafb.mp4";